module.exports = __webpack_public_path__ + "img/t2-12.62676e95.svg";